// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__2vy9n","img":"Login_img__37J9S","forgot":"Login_forgot__2nok_","signUpBtn":"Login_signUpBtn__1dYbl"};
    if(module.hot) {
      // 1686459253943
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  